/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-use-before-define */
import moment from '@narvar/moment-shim';
import extend from 'extend';
import mapPickupData from '../../components/ScheduledPickup/lib/mapPickupData';
import mapCustomerData from '../../components/ScheduledPickup/lib/mapCustomerData';
import mapReturnData from '../../components/ScheduledPickup/lib/mapReturnData';
import { mapMethodData, mapSidebarData } from '../../components/ScheduledPickup/lib/mapDataDisplay';
import { receiveCarrierPickupSubmit } from '../../actions/carrierPickup';
import { updateStep2Complete } from '../../actions/page';
import { PICKUP_COMPLETE } from '../../constants/broadcastEvents';
import { orderService, returnItemsService } from './..';
import { store } from '../../store';

const scheduledPickupService = () => {
  const node = document.createElement('div');
  document.body.appendChild(node);
  const http = location.protocol;
  const slashes = http.concat('//');
  const hostUrl = slashes.concat(window.location.hostname);

  let pickupState = {
    loading: true,
    showError: false,
    businessAddress: false,
    open: false,
    panel: 0,
    config: {},
    currentData: {
      pickupData: {},
      pickupDetails: [],
      scheduleData: {},
      editAddressData: {},
      addressData: {},
      finalPickupDetails: {},
    },
  };

  const getPickupInfo = (pickupData = {}) => {
    const {
      page: { browserFingerprint },
    } = store.getState();
    const { config: { return_carrier: carrierMoniker } = {} } = pickupState;
    const { order_info: { retailer, order_number: orderNumber } = {} } = orderService.getOrder();
    const pickupUrl = `${hostUrl}/schedules/carrier/${carrierMoniker}/retailer/${retailer}/pickups`;

    const requestData = {
      order_number: orderNumber,
      return_method: 'pickup',
      return_carrier: carrierMoniker,
      business_address: pickupState.businessAddress,
      return_items: returnItemsService.getItems(),
      ...mapPickupData(pickupData),
    };

    return fetch(pickupUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'narvar-tfid': browserFingerprint,
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => ({ data }));
  };

  const updateState = (newState, deep = true) => {
    pickupState = extend(deep, pickupState, newState);
    renderSidebar();
  };

  const actions = {
    initialize: (payload) => updateState({ config: { ...payload } }),

    startLoad: () => updateState({ loading: true }),

    finishLoad: () => updateState({ loading: false }),

    error: (showError) => updateState({ showError }),

    open: () => updateState({ open: true }),

    close: () => updateState({ open: false }),

    changePanel: () => updateState({ ...switchPanel() }),

    fetchPickupDates: async () => {
      actions.startLoad();
      try {
        const {
          data: resultData,
          data: {
            pickup_dates: pickupDates = [],
            error_response: { error_code: errorCode, error_message: errorMessage } = {},
          } = {},
        } = await getPickupInfo();

        const error = errorMessage || errorCode;

        if (error) throw new Error(error);

        actions.storeApiData(resultData);
        actions.newPickupDetails({
          pickupDetails: resultData,
        });
        actions.finishLoad();
        if (!pickupDates.length) actions.error(true);
      } catch (err) {
        actions.finishLoad();
        console.error(err); // eslint-disable-line no-console
      }
    },

    newPickupDetails: (payload) =>
      updateState(
        {
          currentData: {
            ...pickupState.currentData,
            ...mapPickupDetails(payload),
          },
        },
        false,
      ),

    storeApiData: (payload) =>
      updateState({
        currentData: {
          pickupData: {
            ...payload,
            shipment_pickup_at: payload.pickup_at_locations,
          },
          scheduleData: {
            shipment_pickup_at: payload.pickup_at_locations[0],
          },
        },
      }),

    businessAddress: () =>
      updateState({
        businessAddress: !pickupState.businessAddress,
        currentData: { editAddressData: { company_name: null } },
      }),

    saveAddress: (payload) =>
      updateState(
        {
          currentData: {
            ...pickupState.currentData,
            addressData: { ...payload },
          },
        },
        false,
      ),

    saveDate: (payload) =>
      updateState({
        currentData: {
          scheduleData: { pickup_date: payload && payload.toJSON() },
        },
      }),

    handleFormChange: (fieldName) => (payload) => {
      updateState({ currentData: { ...formInput(payload, fieldName) } });
    },

    resetForm: (payload) =>
      updateState(
        {
          currentData: { ...pickupState.currentData, [payload]: {} },
        },
        false,
      ),

    resetPickupDate: () =>
      updateState(
        {
          currentData: {
            ...pickupState.currentData,
            scheduleData: {
              ...pickupState.currentData.scheduleData,
              pickup_date: undefined,
            },
          },
        },
        false,
      ),

    finalizePickupDetails: () =>
      updateState(
        {
          currentData: {
            ...pickupState.currentData,
            finalPickupDetails: { ...getFinalDetails() },
          },
        },
        false,
      ),
  };

  const formInput = (inputData, fieldName) => {
    const formName = pickupState.panel ? 'editAddressData' : 'scheduleData';
    const { value: inputValue } = inputData.target;

    if (inputValue === '') {
      delete pickupState.currentData[formName][fieldName];
    } else {
      return { [formName]: { [fieldName]: inputValue } };
    }
  };

  const switchPanel = () => {
    const { panel, currentData: { pickupData: { pickup_dates: pickupDates = [] } = {} } = {} } =
      pickupState;
    const nextPanel = panel ? 0 : 1;

    actions.error(false);

    if (nextPanel === 0) {
      if (!pickupDates.length) actions.error(true);
    } else {
      actions.resetForm('editAddressData');
    }

    return { panel: nextPanel };
  };

  const mapPickupDetails = ({ pickupDetails }) => {
    const { pickup_dates } = pickupDetails;

    return {
      pickupDetails: mapSidebarData(pickupDetails),
      ...(pickup_dates ? { pickup_dates: mapPickupDates(pickup_dates) } : {}),
    };
  };

  const getMethodPickupDetails = () => {
    const { currentData: { finalPickupDetails } = {} } = pickupState;

    return mapMethodData(finalPickupDetails);
  };

  const updateSidebarDetails = (pickupData) => {
    actions.startLoad();

    getPickupInfo(pickupData)
      .then((result) => {
        const resultData = result.data;
        const errorResponse = resultData.error_response;
        const { error_code, error_message } = errorResponse;

        if (resultData.pickup_dates.length && !error_code && !error_message) {
          actions.storeApiData(resultData);
          actions.newPickupDetails({ pickupDetails: resultData });
          actions.saveAddress(pickupData);
          actions.resetForm('editAddressData');
          actions.changePanel();
          actions.finishLoad();
        } else {
          actions.error(true);
          actions.finishLoad();
          throw new Error(errorResponse);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getPickupDate = () => pickupState.currentData.finalPickupDetails.pickup_date;

  const mapPickupDates = (pickupDates) =>
    pickupDates.map((date) => new Date(date.pickup_date.split('-').join('/')));

  const completePickup = () => {
    const { finalPickupDetails } = pickupState.currentData;

    if (Object.keys(finalPickupDetails).length && finalPickupDetails.pickup_date) {
      store.dispatch(receiveCarrierPickupSubmit(finalPickupDetails));
      store.dispatch(updateStep2Complete(true));
      const event = new Event(PICKUP_COMPLETE);
      window.dispatchEvent(event);
    }
  };

  const getFinalDetails = () => {
    const { pickupData, scheduleData, addressData } = pickupState.currentData;
    let finalPickupDetails;

    if (Object.keys(addressData).length) {
      finalPickupDetails = { ...addressData, ...mapCustomerData(pickupData) };
    } else {
      finalPickupDetails = { ...mapPickupData(pickupData) };
    }

    finalPickupDetails = {
      ...finalPickupDetails,
      ...scheduleData,
      business_address: pickupState.businessAddress,
    };

    actions.newPickupDetails({ pickupDetails: finalPickupDetails });

    return finalPickupDetails;
  };

  const buildScheduledPickupOrder = (order) => {
    const { finalPickupDetails } = pickupState.currentData;
    return {
      ...order,
      request_date: moment.utc().toJSON(),
      business_address: pickupState.businessAddress,
      return_carrier: pickupState.config.return_carrier,
      shipping_method: pickupState.config.shipping_method,
      ship_by_date: orderService.getOrder().order_info.ship_by_date,
      ...mapReturnData(finalPickupDetails),
    };
  };

  const isFieldComplete = (fieldsComplete, nextField) => {
    const {
      panel,
      config: { sidebarPanel: { [panel]: { name: formName } = {} } = {} } = {},
      currentData = {},
      currentData: { [formName]: formData = {} } = {},
    } = pickupState;

    return (formData[nextField] && fieldsComplete) || (currentData[nextField] && panel !== 1);
  };

  const isPickupDateComplete = () => {
    const {
      config: { pickupDateRequired } = {},
      currentData: { scheduleData: { pickup_date: pickupDate } = {} } = {},
    } = pickupState;

    return !pickupDateRequired || pickupDate;
  };

  const checkRequiredInputs = () => {
    const {
      businessAddress,
      panel,
      config: {
        sidebarPanel: {
          [panel]: { requiredFields = [], conditionalRequiredFields = [] } = {},
        } = {},
      } = {},
    } = pickupState;

    const requiredFieldsComplete = requiredFields.reduce(isFieldComplete, true);
    const conditionalFieldsComplete = businessAddress
      ? conditionalRequiredFields.reduce(isFieldComplete, true)
      : true;
    const pickupDateComplete = isPickupDateComplete();

    return requiredFieldsComplete && conditionalFieldsComplete && pickupDateComplete;
  };

  const submitAddressForm = () => {
    const {
      panel,
      showError,
      currentData: { editAddressData = {} },
    } = pickupState;

    if (showError || !checkRequiredInputs()) return actions.error(false);

    if (panel === 1) {
      actions.resetPickupDate();

      return updateSidebarDetails(editAddressData);
    }

    actions.finalizePickupDetails();
    completePickup();

    return actions.close();
  };

  const confirmPickupDetails = () => {
    const {
      showError,
      panel,
      config: { sidebarPanel: { [panel]: { name: formName } = {} } = {} } = {},
      currentData: { [formName]: formData = {} } = {},
    } = pickupState;

    if (showError || !checkRequiredInputs()) return actions.error(false);

    if (panel === 1) {
      actions.resetPickupDate();

      return updateSidebarDetails(formData);
    }

    actions.finalizePickupDetails();
    completePickup();
    actions.close();
  };

  const renderSidebar = async () => {
    const handlers = {
      checkRequiredInputs,
      confirmPickupDetails,
      submitAddressForm,
    };
    const module = await import(
      /* webpackChunkName: "scheduled-pickup" */ `../../components/ScheduledPickup/scheduledPickup`
    );

    module.renderScheduledPickup({
      pickupState,
      actions,
      handlers,
      node,
    });
  };

  return {
    actions,
    getPickupDate,
    getPickupInfo,
    getMethodPickupDetails,
    buildScheduledPickupOrder,
  };
};

export const scheduledPickup = scheduledPickupService();
